module.exports = __webpack_public_path__ + "img/truck_without_trailer.8b65f121.svg";